import React from 'react'
import ReactDOM from 'react-dom/client'
// import App from './App'
import Main from './main'
import './styles/global.scss'
import './styles/index.css'

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <Main />
  </React.StrictMode>,
)


